import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import CrearTipoCompetencia from "./components/CrearTipoCompetencia";
import ListaTipoCompetencias from "./components/ListaTipoCompetencias";
import { useGetListaTipoCompetenciaQuery } from "../../../../redux/services/tipoCompetencia";
import { MenuContext } from "../../../../context/MenuContext";

const TipoCompetencias = () => {
  const [tipoCompetencia, setTipoCompetencia] = React.useState([]);

  const { data: dataTipoCompetencia, isLoading: isLoadingTipoCompetencia } =
    useGetListaTipoCompetenciaQuery();

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const filtrado = dataTipoCompetencia?.listaTipoCompetencia?.filter(
          (tipo) => tipo.activo !== false
        );
        setTipoCompetencia(filtrado);
      } catch (error) {
        console.error("Error al obtener los posts:", error);
      }
    };

    fetchData();
  }, [dataTipoCompetencia]);

  const { menuState } = useContext(MenuContext);
  return (
    <React.Fragment>
      <Box>
        <Box
          className={`${
            menuState ? "contPrincipalPXC menuAbiertoPXC" : "contPrincipalPXC"
          }`}
        >
          <Grid container style={{ flexDirection: "row" }}>
            <Grid
              item
              xs={12}
              style={{ flexDirection: "column" }}
              className="gridColumnaPXC"
            >
              {tipoCompetencia ? (
                <Box className="boxCalendarioPXC">
                  <Typography className="Titulo" sx={{ marginBottom: "15px" }}>
                    Tipos de Competencias:
                  </Typography>
                  {tipoCompetencia?.length === 0 ? (
                    <Typography
                      className="Titulo"
                      style={{ fontSize: 14, alignSelf: "center" }}
                    >
                      No hay Tipos de Competencias para mostrar.
                    </Typography>
                  ) : (
                    tipoCompetencia.map((tipo) => (
                      <ListaTipoCompetencias
                        key={tipo.id}
                        Tipo={tipo}
                        Origen={"auth"}
                      />
                    ))
                  )}
                </Box>
              ) : isLoadingTipoCompetencia ? (
                <CircularProgress />
              ) : (
                <Typography className="Titulo">
                  {" No hay tipo de Competencias para mostrar."}
                </Typography>
              )}
              <Divider sx={{ width: "100%", m: 2 }} />
              <Box style={{ width: "100%" }} className="">
                <CrearTipoCompetencia sinmenu={true} />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default TipoCompetencias;
